import React, { Component } from 'react';

class Image extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageStatus: 'loading',
      imageUrl: this.props.imageUrl,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.imageUrl !== this.state.imageUrl) {
      this.setState({
        loaded: false,
        imageUrl: nextProps.imageUrl,
      });
    }
  }

  handleImageLoaded() {
    this.setState({ loaded: true });
  }

  handleImageErrored() {
    this.setState({ loaded: false });
  }

  render() {
    const { imageUrl } = this.props;
    const { loaded } = this.state;

    return (
      <img
        className={`image-component ${loaded && 'loaded'}`}
        src={imageUrl}
        onLoad={this.handleImageLoaded.bind(this)}
        onError={this.handleImageErrored.bind(this)}
      />
    );
  }
}
export default Image;



/** WEBPACK FOOTER **
 ** ./src/components/image/index.js
 **/